import { render } from "./ChangePhoneComponent.vue?vue&type=template&id=e5092956"
import script from "./ChangePhoneComponent.vue?vue&type=script&lang=js"
export * from "./ChangePhoneComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen/autoringen.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/user/ChangePhoneComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5092956"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5092956', __exports__)) {
    console.log('reload')
    api.reload('e5092956', __exports__)
  }
  
  module.hot.accept("./ChangePhoneComponent.vue?vue&type=template&id=e5092956", () => {
    console.log('re-render')
    api.rerender('e5092956', render)
  })

}


export default __exports__